module.exports = __webpack_public_path__ + "static/media/1POLICY28.ad12a950.jpg";